import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-minimal-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <div class="minimal-layout">
      <!-- Only the main content, no footer -->
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [`
    .minimal-layout {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }
  `]
})
export class MinimalLayoutComponent {} 